module.exports = __webpack_public_path__ + "img/m_explan_02.jpg";